export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
        authority: process.env.REACT_APP_AZURE_AUTHORITY,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: [`api://${process.env.REACT_APP_AZURE_CLIENT_ID}/access_as_user`]
};

export const graphRequest = {
    scopes: ['User.Read.All', 'LicenseAssignment.Read.All']
};
